import * as React from 'react';

import { cn } from '@/lib/utils';

function Label({ className, ...props }: React.ComponentProps<'label'>) {
  return (
    <label
      data-slot="label"
      className={cn(
        'flex items-center gap-2 text-sm leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50',
        className,
      )}
      {...props}
    />
  );
}

/**
 * The mark on a field that must be filled in.
 *
 * Rendered *beside* the `<label>` rather than inside it, which is the whole
 * point of it being a component. Inside, it would join the label's text — so
 * the field would be called "Name *" by anything reading the label's content,
 * including every `getByLabelText('Name')` in the test suite. Outside and
 * `aria-hidden`, the field is still called "Name", and the requirement is
 * carried by `aria-required` on the control, which is what assistive technology
 * reads for it anyway.
 *
 * Decoration for sighted users, in other words, with the semantics kept where
 * they belong.
 */
function RequiredMark() {
  return (
    <span aria-hidden="true" className="text-destructive text-sm leading-none">
      *
    </span>
  );
}

export { Label, RequiredMark };
